
import { css } from 'lit';
export default css`
.print-button {
  font-weight: 700;
  margin-right: 1.5rem;
  margin-left: 2.5rem;
  font-size: 18px;
  display: flex;
  align-items: center;
}

  .print-button__icon {
    width: 1rem;
    height: 1rem;
    margin-left: 12px;
    margin-top: 0.375rem;
  }

  .print-button:hover {
    text-decoration: underline;
  }

  .print-button--purple {
  font-weight: 900;
}

  .print-button--purple {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .print-button--purple {
    font-size: 18px;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin-right: 2rem;
  }

  .print-button--purple .print-button__icon {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .print-button--purple .print-button__icon {
      width: 29px;
      height: 22px;
      margin-top: 0;
    }

  .print-button--purple:hover {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}

  .print-button--purple:hover .print-button__icon {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}
`;